// Copyright (c) 2021 Deere & Company

import React, {PropTypes} from 'react';
import AdditionalFields from '../../../claim/mass-labor-rate-change/components/additional-fields';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';

const LaborRateMain = props =>
    <div className='labor-rate-change-panel'>
        <AdditionalFields
            actions={props.actions}
            allSelected={props.allSelected}
            laborRate={props.laborRate}
            tcsm={props.tcsm}
        >
            {props.children}
        </AdditionalFields>
    </div>;

LaborRateMain.displayName = 'LaborRateMain';
LaborRateMain.propTypes = {
    actions: PropTypes.object.isRequired,
    allSelected: PropTypes.bool,
    children: PropTypes.node,
    laborRate: PropTypes.instanceOf(LaborRate).isRequired,
    tcsm: PropTypes.bool.isRequired
};

export default LaborRateMain;



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/components/labor-rate-main.js